import React from "react";
import {ListItem, Paragraph, PolicyTitle, SubHeading} from "../PrivacyPolicyText";

const CaliforniaPrivacySection = () => (
  <>
    <SubHeading>{"Your California Privacy Rights"}</SubHeading>

    <Paragraph>
      {"We do not sell, trade, or otherwise transfer your Personal Information to third parties, except as expressly stated in this Policy. California Civil Code Section § 1798.83 permits California residents to request certain information regarding our use and disclosure of Personal Information to third parties. To make such a request, please send an e-mail to support@evenplay.com. Further, the California Consumer Privacy Act of 2018, as amended (Cal. Civ. Code §§ 1798.100 to 1798.199) (“CCPA”), does not apply to us. If you have any questions or concerns about the CCPA or its non-applicability to us, please e-mail Us at support@evenplay.com. California “Shine the Light” Law"}
    </Paragraph>

    <Paragraph>
      {"Separate from CCPA, California residents may, pursuant to California Civil Code Section 1798.83 (the California “Shine the Light” law), request certain information regarding our disclosure (if any) of personal data to third parties for their direct marketing purposes. To make such a request, please contact us, identify yourself as a California resident and provide sufficient information so We can take appropriate action, such as your name, email address or any additional information required."}
    </Paragraph>

    <PolicyTitle noMargin>{"CALIFORNIA-SPECIFIC PRIVACY RIGHTS (for California residents only)"}</PolicyTitle>

    <SubHeading>{"California Consumer Privacy Act (CCPA)"}</SubHeading>

    <Paragraph>
      {"This California Privacy Notice supplements the Privacy Policy (“Policy”) and contains the disclosures required under the California Consumer Privacy Act (CCPA). For individuals who are California residents, the CCPA requires certain disclosures about the categories of personal information We collect and how We use it, the categories of sources from whom We collect personal information, and the third parties with whom We share it. You have also the right to exercise certain rights regarding your personal information."}
    </Paragraph>

    <Paragraph>
      {"Please note that for California residents, the term personal information means information that identifies, relates to, describes, is reasonably capable of being associated with or could reasonably be linked, directly or indirectly, with a particular consumer or household as defined in the CCPA. All other capitalized terms have the same meanings as given them in the Policy."}
    </Paragraph>

    <SubHeading>{"Data Subject Requests"}</SubHeading>

    <Paragraph>
      {"If you are a California resident who has provided personal information to us, or a California resident that reasonably believes that We have collected or stored their personal information, you have the right to request Company to:"}
    </Paragraph>

    <ListItem>
      {"Disclose the categories of personal information We collected about you in the preceding twelve months; categories of sources from which the personal information was collected; the business or commercial purpose for which We collected or sold the personal information; the categories of third parties with which We have shared your personal information; categories of personal information that We sold in the preceding twelve months, and for each category identified, categories of third parties to which We sold that particular category of personal information; and the categories of personal information that We disclosed for a business purpose in the preceding twelve months, and for each category identified, the categories of third parties to whom We disclosed that particular category of personal information (“Request to Know”);"}
    </ListItem>

    <ListItem>
      {"Disclose the specific pieces of personal information that We have collected on you (“Request to Know”);"}
    </ListItem>

    <ListItem>{"Delete personal information We have collected on you (“Request to Delete”); and"}</ListItem>

    <ListItem withBottomMargin>
      {"Opt out of the sale of the personal information We have collected on you (“Right to Opt Out”)."}
    </ListItem>

    <Paragraph>
      {"You can only make two Requests to Know in a twelve-month period, and the information provided need only cover the twelve-month period prior to receipt of your request."}
    </Paragraph>

    <SubHeading>{"Methods for Submitting Request"}</SubHeading>

    <Paragraph>
      {"You may submit Requests to Know and Requests to Delete in one of the following methods: (a) writing to Us at 2575 S Highland Dr, Las Vegas, NV 89101 or (b) by sending an email to support@evenplay.com."}
    </Paragraph>

    <SubHeading>{"Verification of Requests"}</SubHeading>

    <Paragraph>
      {"We will need to verify your identity to respond to Requests to Delete and Requests to Know. If you have an account with Us that is password-protected, We may verify your identity through our existing authentication practices for your account."}
    </Paragraph>

    <Paragraph>
      {"If you do not have an account with us, and your request concerns “categories” of personal information collected, We can request from you two data points of personal information to verify your identity. If you do not have an account with us, and your request concerns specific pieces of personal information, We can request from you at least three data points of personal information as well as a signed declaration made under penalty of perjury to verify your identity."}
    </Paragraph>

    <Paragraph>
      {"If a request concerns household information, and the household does not have a password-protected account with us, We will not comply with a Request to Know specific pieces of personal information about the household or a Request to Delete household personal information unless all of the following conditions are satisfied: (1) all consumers of the household jointly request access to specific pieces of information for the household or the deletion of household personal information; (2) We have individually verified all the members of the household under the CCPA; and (3) We have verified that each member making the request is currently a member of the household."}
    </Paragraph>

    <SubHeading>{"Time for Response"}</SubHeading>

    <Paragraph>
      {"Please note that once you have submitted a Request to Know or Request to Delete, We will send you a receipt, acknowledging your request, within ten business days. If, for some reason, you do not receive such a receipt within ten days of your submitted request, please send Us an email to support@evenplay.com as an error may have occurred."}
    </Paragraph>

    <Paragraph>
      {"We will respond to Requests to Know and Requests to Delete within forty-five calendar days after they are received. If We cannot verify you within the forty-five-day time period, We may deny the request. If necessary, We may take up to an additional forty-five calendar days to respond to the consumer’s request, for a maximum total of ninety calendar days from the day the request is received, provided that We provide you with notice and an explanation of the reason that We will take more than forty-five days to respond to the request."}
    </Paragraph>

    <Paragraph>
      {"In the case of a Request to Delete, We may use a two-step process for online requests to delete where you must first, submit the Request to Delete and then second, separately confirm that you want your personal information deleted."}
    </Paragraph>

    <SubHeading>{"Notice of Opt Out"}</SubHeading>

    <Paragraph>
      {"You have the right to opt out of the sale of your personal information by us. To exercise this right, you can use this form or send an email to dataprotection@evenplay.com. We will comply with a Request to Opt Out as soon as feasibly possible, but no later than fifteen business days from the date We received the request."}
    </Paragraph>

    <SubHeading>{"Authorized Agent"}</SubHeading>

    <Paragraph>
      {"As a California resident, you have the right to designate an agent to exercise these rights on your behalf. We may require proof that you have designated the authorized agent to act on your behalf and to verify your identity directly with us. Please contact Us at support@evenplay.com for more information if you wish to submit a request through an authorized agent."}
    </Paragraph>

    <SubHeading>{"Right to Non-Discrimination for the Exercise of CCPA Rights"}</SubHeading>

    <Paragraph>
      {"We will not discriminate against you for exercising any of your CCPA rights. Unless permitted by the CCPA, We will not:"}
    </Paragraph>

    <ListItem>{"Deny you goods or services."}</ListItem>

    <ListItem>
      {"Charge you different prices or rates for goods or services, including through granting discounts or other benefits, or imposing penalties."}
    </ListItem>

    <ListItem>{"Provide you a different level or quality of goods or services."}</ListItem>

    <ListItem withBottomMargin>
      {"Suggest that you may receive a different price or rate for goods or services or a different level or quality of goods or services."}
    </ListItem>

    <Paragraph>
      {"However, We may offer you certain financial incentives permitted by the CCPA that can result in different prices, rates, or quality levels. Any CCPA-permitted financial incentive We offer will reasonably relate to your personal information's value and contain written terms that describe the program's material aspects. Participation in a financial incentive program requires your prior opt-in consent, which you may revoke at any time."}
    </Paragraph>

    <SubHeading>{"Contact Us"}</SubHeading>

    <Paragraph>
      {"If you have questions about our privacy policies or practices or this notice, please contact Us at support@evenplay.com."}
    </Paragraph>
  </>
);

export default CaliforniaPrivacySection;
